import { Link } from "react-router-dom";

const consultationAreas = [
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Investor Readiness",
    desc: "Structured guidance to help you understand your financial position, clarify your goals, and prepare for long-term investment decisions.",
  },
  {
    icon: "ri-compass-3-line",
    title: "Financial Advisory",
    desc: "Personalized advisory conversations covering financial education, cross-border opportunity, and wealth-building strategy for the African Diaspora.",
  },
  {
    icon: "ri-global-line",
    title: "Strategic Guidance",
    desc: "Cross-border advisory support for entrepreneurs, families, and professionals navigating African and diaspora market opportunities.",
  },
];

export default function ConsultationSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <img
            src="/assets/images/site/consult-section-001-640x520.jpg"
            alt="Harambee Global Ventures advisory consultation"
            className="w-full h-[420px] object-cover object-top rounded-lg"
          />
          <div className="absolute -bottom-6 -right-6 bg-[#1A4D3C] rounded-lg p-6 max-w-[220px] hidden lg:block">
            <div className="text-[#C9A961] font-['Cormorant_Garamond'] text-3xl font-bold mb-1">1:1</div>
            <div className="text-white text-xs leading-relaxed">Personalized advisory sessions tailored to your goals and context</div>
          </div>
        </div>

        <div>
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Advisory Consultations
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            Schedule a Consultation with Our Advisory Team
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            Qualified individuals and organizations are invited to schedule a consultation with the Harambee Global Ventures advisory team. Whether you are seeking investor readiness support, financial education, or strategic cross-border guidance — we are here to help you move forward with clarity and confidence.
          </p>
          <div className="rounded-lg border border-[#E8E4DC] bg-[#F8F6F3] p-5 mb-8">
            <p className="text-[#6B6B6B] text-sm leading-relaxed">
              Consultation requests are for educational and strategic discussions only. They do not constitute a public offering, solicitation of securities, or personalized legal, accounting, or investment advice. Capital-related pathways, where discussed, are subject to qualification and compliance review.
            </p>
          </div>

          <div className="space-y-5 mb-10">
            {consultationAreas.map((area) => (
              <div key={area.title} className="flex items-start gap-4 p-5 rounded-lg bg-[#F8F6F3] border border-[#E8E4DC]">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0">
                  <i className={`${area.icon} text-[#1A4D3C] text-base`} />
                </div>
                <div>
                  <div className="font-semibold text-[#2B2D2F] text-sm mb-1">{area.title}</div>
                  <div className="text-[#6B6B6B] text-xs leading-relaxed">{area.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/advisory"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md bg-[#1A4D3C] text-white font-semibold text-sm hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Consultation <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="#contact-form"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md border border-[#1A4D3C]/30 text-[#1A4D3C] font-medium text-sm hover:border-[#1A4D3C] transition-colors whitespace-nowrap cursor-pointer"
            >
              Ask a Question First
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
